<template src="./riepilogoOre.html"></template>

<script>
import { get_utenti, get_clienti } from "@/api/api.calendar.js";

import TabellaRiepilogo from "./TabellaRiepilogo.vue";
import RiepilogoPreventivi from "./RiepilogoPreventivi.vue";
import FiltriRiepilogoOre from './FiltriRiepilogoOre.vue'

import { get_oreClienti } from "@/api/api.clienti.js";
import mixinr from "./mixinRiepilogo.js";
import storage from "@/services/storage.js";

export default {

  components: {
    TabellaRiepilogo,
    FiltriRiepilogoOre,
    RiepilogoPreventivi
  },

  mixins: [mixinr],

  data: () => ({
    search: "",
    filtri: {},
    showFiltriMobile: false,

    calendarDataDa: false,
    calendarDataA: false,
    mcalendarDataDa: false,
    mcalendarDataA: false,

    elencoClienti: [],
    elencoOperatori: [],
    destinazioni: [],
    tipiOre: [],

    elencoDati: [],
    totaliPreventivi: [],
    totale: {},

    includiOreUfficio: false,
    raggruppaClienti: false,
    separaOperatori: false,
    soloDafatturare: true,

    // Dialog di dettaglio che si apre sul click di una riga ragguppata
    dettaglioDati: [],
    dialogInfo: false,
    dettaglioTotale: {},
    activeTab: 0,
  }),

  methods: {
    async caricaDati() {
      this.caricaOperatori();
      this.caricaClienti();
      this.caricaOreClienti();
    },

    async caricaOperatori() {
      let res = await get_utenti();
      this.elencoOperatori = res.data;
    },

    async caricaClienti() {
      let res = await get_clienti();
      this.elencoClienti = res.data;
    },

    async caricaOreClienti() {
      if (
        this.filtri.dataDa == null ||
        this.filtri.dataDa == "" ||
        this.filtri.dataA == null ||
        this.filtri.dataA == ""
      ) {
        return;
      }
      if (!this.raggruppaClienti) this.separaOperatori = false;
      let res = await get_oreClienti(
        "?raggruppa=" + (this.raggruppaClienti ? "1" : "0") +
        "&separaOp=" + (this.separaOperatori ? "1" : "0") +
        "&soloDafatturare=" + (this.soloDafatturare ? "1" : "0"),
        this.filtri
      );
      this.elencoDati = res.data.elenco;
      this.totale = res.data.totale;
      this.totaliPreventivi = res.data.totaliPreventivi;
    },

    refresh() {
      this.caricaDati();
    },

    dateDefault() {
      let date = new Date();
      this.filtri.dataA = date.toISOString().substring(0, 10);
      this.filtri.dataDa = new Date(date.getFullYear(), date.getMonth(), 1 + 1)
        .toISOString()
        .substring(0, 10);
    },

    async dettaglioCliente(item) {
      console.log(item);
      this.dialogInfo = true;
      let filtriL = {};
      Object.assign(filtriL, this.filtri);
      // Sul click di una riga delle ore in ufficio senza cliente va in errore il dettaglio perciò esco: 
      // sarebbe da modificare la funzione per il recupero dati e gestire il cliente vuoto
      try {
        filtriL.cliente = this.elencoClienti.filter(
          (c) => c.ragSoc == item.cliente
        )[0].codAnagrafica;
      }
      catch (exception) {
        this.dialogInfo = false;
        return;
      }
      filtriL.destinazione = item.destinazione;
      if (this.separaOperatori) filtriL.operatore = [item.operatore]

      let par = "?soloDafatturare=" + (this.soloDafatturare ? "1" : "0");
      let res = await get_oreClienti(par, filtriL);
      this.dettaglioDati = res.data.elenco;
      this.dettaglioTotale = res.data.totale;
    },

    getFullscreen() {
      return this.$functions.isMobile();
    },

  },

  mounted() {
    this.filtri = this.getFiltri();
    this.destinazioni = this.getDestinazioni();
    this.tipiOre = this.getTipiOre();

    this.dateDefault();
    this.caricaDati();
  },

  created() {
    if (this.role != "admin") this.$router.push({ path: "/" });
  },

  computed: {
    role() {
      return storage.getRole();
    },
  },

  watch: {
    "filtri.dataDa": function (newVal, oldVal) {
      if (
        newVal != null &&
        newVal != "" &&
        this.filtri.dataA != null &&
        this.filtri.dataA != "" &&
        newVal > this.filtri.dataA
      ) {
        this.filtri.dataDa = oldVal;
        this.$toast.alert("Data non valida");
      }
      this.filtri.dataDaIT = this.$i2kFunctions.formatISODate(
        this.filtri.dataDa
      );
    },

    "filtri.dataA": function (newVal, oldVal) {
      if (
        newVal != null &&
        newVal != "" &&
        this.filtri.dataDa != null &&
        this.filtri.dataDa != "" &&
        newVal < this.filtri.dataDa
      ) {
        this.filtri.dataA = oldVal;
        this.$toast.alert("Data non valida");
      }
      this.filtri.dataAIT = this.$i2kFunctions.formatISODate(this.filtri.dataA);
    },
  },
};
</script>

<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}

.totale {
  font-weight: bold;
  font-size: 1.1em;
  padding: 0;
  vertical-align: middle;
  display: flex;
  align-items: center;
}

.desktop-filters {
  border-radius: 5px;
  padding: 0.5rem;
}

.mobile-filters-toggle {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  background: var(--v-primary-base);
  color: white;
  border-radius: 50%;
}

.conteggio-prev {
  font-weight: bold;
  font-size: 1.2em;
}
</style>